import { DefaultCurrencyISO3 } from '@/types/global';
import { useSettings } from "@/store";

export function formatNumberToString(num: number, options?: Intl.NumberFormatOptions): string {
  const currencySettings = useSettings().settings?.numberFormatOptions?.currency;
  const formatter = new Intl.NumberFormat('en-IE', options ? options : currencySettings ? { ...currencySettings, style: 'currency'} : {
    style: 'currency',
    currency: getCurrency(),
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(num)
}

export function formatPercentageToString(num: number, options?: Intl.NumberFormatOptions): string {
  const settings = useSettings().settings?.numberFormatOptions?.percentage;
  const formatter = new Intl.NumberFormat('en-IE', options ? options : settings ? { ...settings, style: 'percent'} : {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  return formatter.format(num);
}

export function getCurrencySymbol(options?: Intl.NumberFormatOptions): string {
  const formatted =  new Intl.NumberFormat(undefined, { style: 'currency', currency: options && options.currency ? options.currency : getCurrency() }).formatToParts(1)
  const currency = formatted.find(part => part.type === 'currency')?.value;
  return formatted && currency ? currency : '€';
}

export function getCurrency(): DefaultCurrencyISO3 {
  const settings = useSettings().settings;
  const currencySettings = settings?.numberFormatOptions?.currency?.currency;
  return currencySettings 
    ? (currencySettings as DefaultCurrencyISO3)
    : settings && settings.country && DefaultCurrencyISO3[settings.country]
    ? DefaultCurrencyISO3[settings.country] 
    : DefaultCurrencyISO3.IRL;
}